import { createContext, useState, useEffect } from "react";
import { BACKEND_URL } from "../config";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(() => {
  const storedUser = localStorage.getItem("user");
  return storedUser ? JSON.parse(storedUser) : null;
});

 

    useEffect(() => {

      fetch(
        `${BACKEND_URL}/api.php?module=auth&action=check_auth`,
        {
          credentials: "include"
        }
      )
        .then(res => res.json())
        .then(data => {

          if (data.success) {

            setUser(data.user);

            localStorage.setItem(
              "user",
              JSON.stringify(data.user)
            );

          } else {

            setUser(null);

            localStorage.removeItem("user");
          }

        })
        .catch(() => {

          setUser(null);

          localStorage.removeItem("user");

        });

    }, []);

  const [showAuth, setShowAuth] = useState(false);

  // 🔥 NEW (important)
  const [authMode, setAuthMode] = useState("signin");


  const isLoggedIn = !!user;

  const logout = () => {
  localStorage.removeItem("user");
  setUser(null);
};

  return (
    <AuthContext.Provider value={{
      user,
      setUser,
      showAuth,
      setShowAuth,
      authMode,
      setAuthMode,
      isLoggedIn,
      logout
    }}>
      {children}
    </AuthContext.Provider>
  );
};